import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "./assets/loader.json";
import "./Spinner.scss";
import Flex from "./Flex";

const Spinner = () => {
  return (
    <Flex className="Spinner">
      <Lottie animationData={loaderAnimation} loop autoplay />
    </Flex>
  );
};

export default Spinner;
